import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "as-line-up-colunm-item" }
const _hoisted_2 = { class: "as-line-up-colunm-item" }

import { computed } from "vue";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import PlayerItemTab from "~src/components/lineups/PlayerItemTab.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
  isInjuredSuspended: boolean;
  isSubstituted: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayersTab',
  props: {
    lineups: {},
    match: {},
    startingPlayers: {},
    isInjuredSuspended: { type: Boolean, default: false },
    isSubstituted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();



const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-line-up-colunm", {
      'as-line-up-colunm-sm': screenWidth.value < 370,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.home, (player, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["as-line-up-item as-line-up-item-home", {
          'as-line-up-item-last':
            `${key}` === `${_ctx.startingPlayers.home.length - 1}`,
        }])
        }, [
          _createVNode(PlayerItemTab, {
            player: player,
            isInjuredSuspended: _ctx.isInjuredSuspended,
            isSubstituted: _ctx.isSubstituted
          }, null, 8, ["player", "isInjuredSuspended", "isSubstituted"])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.away, (player, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["as-line-up-item as-line-up-item-away", {
          'as-line-up-item-last':
            `${key}` === `${_ctx.startingPlayers.home.length - 1}`,
        }])
        }, [
          _createVNode(PlayerItemTab, {
            player: player,
            flex: "end",
            isInjuredSuspended: _ctx.isInjuredSuspended,
            isSubstituted: _ctx.isSubstituted
          }, null, 8, ["player", "isInjuredSuspended", "isSubstituted"])
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})